import { Box, IconButton, Stack } from "@mui/material";
import React from "react";
import { AiOutlineLogout } from "react-icons/ai";
import { Outlet, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo_TS.png";
import { useProfileContext } from "../contexts";
import { GetUser } from "../helpers/api.helpers";

const useProtectedOutletController = () => {

    const navigate = useNavigate();

    const [profile, setProfile] = useProfileContext();
    const [loader, setLoader] = React.useState(false);

    React.useEffect(() => {

        setLoader(true);
        GetUser()
            .then((res) => {
                setLoader(false);
                setProfile({
                    ...res.data,
                });
            })
            .catch((res) => {
                const code = res?.response?.status || 500;
                setLoader(false);
                navigate(`/errors`, { state: { code } });
            });
    }, []);

    return {
        models: {
            profile,
            loader
        }
    };
};

export const AppOutletLayout = () => {

    useProtectedOutletController();

    const handleLogout = () => {
        window.location.href = window.location.origin + "?clear=true";
    };

    return (
        <Box height="100vh" display="flex" flexDirection="column">
            <Box
                width="100%"
                px={2}
                py={1}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    backgroundColor: '#fff',
                    borderBottom: '2px solid rgb(0, 144, 209)',
                    boxSizing: 'border-box',
                }}
            >
                <Box>
                    <img src={logo} height="36px" alt="Logo" />
                </Box>
                <Stack
                    direction="row"
                    gap={2}
                >
                    <IconButton
                        size="small"
                        onClick={handleLogout}
                        sx={{
                            cursor: "pointer",
                            color: 'rgb(0, 80, 117)',
                            fontWeight: 'bold',
                            ':hover': {
                                opacity: 0.4
                            }
                        }}
                    >
                        <AiOutlineLogout />
                    </IconButton>
                </Stack>
            </Box>
            <Box
                sx={{
                    flexGrow: 1,
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 2,
                    p: 2
                }}
            >
                <Box
                    sx={{
                        flexGrow: 1,
                    }}
                >
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
}